// anyone
export const ROOT = "/";
export const TOPIC_WITH_ID = "/healthTopic/:id";
export const ARTICLE_WITH_ID = "/article/:id";
export const LOGIN = "/login";
export const ARTICLES = "/articles";
export const HEALTH_TOPICS = "/healthTopics";

// logged in user
export const DASHBOARD = "/dashboard";
export const PROFILES = "/profiles";
export const CREATE_PROFILES = "/profiles/create";
export const EDIT_PROFILES = "/profiles/edit";
export const VIEW_PROFILES = "/profiles/view";
export const DOCUMENTS = "/documents";

// Admin
export const ADMIN_DASHBOARD = "/admin/dashboard";
export const ADMIN_ARTICLES = "/admin/articles";
export const ADMIN_ARTICLE = "/admin/article";
export const ADMIN_HEALTH_TOPIC = "/admin/healthTopic";
export const ADMIN_HEALTH_TOPICS = "/admin/healthTopics";

// common
export const UNAUTHORIZED = "/unauthorized";
